import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-auto"
}
const _hoisted_2 = { class: "card py-2 px-2" }
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-success fas fa-check-circle"
}
const _hoisted_6 = {
  key: 1,
  class: "text-danger fas fa-times-circle"
}
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-center"
}
const _hoisted_9 = {
  key: 0,
  class: "text-success fas fa-check-circle"
}
const _hoisted_10 = {
  key: 1,
  class: "text-danger fas fa-times-circle"
}
const _hoisted_11 = {
  key: 1,
  class: "text-center"
}
const _hoisted_12 = {
  key: 2,
  class: "text-center"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 3,
  class: "text-center"
}
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "alert alert-danger mt-2"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "d-inline-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_modal = _resolveComponent("modal")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[19] || (_cache[19] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Manage Passwords"),
      _createElementVNode("p", null, [
        _createElementVNode("small", null, "Update password settings for each partner.")
      ])
    ], -1)),
    (!_ctx.loading && _ctx.partners)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _cache[11] || (_cache[11] = _createElementVNode("thead", { class: "thead-dark" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "header-row py-2 px-2" }, "Partner Name"),
                  _createElementVNode("th", { class: "header-row py-2" }, "Partner Slug"),
                  _createElementVNode("th", { class: "header-row py-2 text-center" }, "Enable Password"),
                  _createElementVNode("th", { class: "header-row py-2 text-center" }, "Password"),
                  _createElementVNode("th", { class: "header-row py-2 text-center" }, "Rotate Password"),
                  _createElementVNode("th", { class: "header-row py-2 text-center" }, "Rotation End Date"),
                  _createElementVNode("th", { class: "header-row py-2 text-center" }, "Rotation Frequency"),
                  _createElementVNode("th", { class: "header-row py-2" }, "Edit")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: partner.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(partner.short_name), 1),
                    _createElementVNode("td", null, _toDisplayString(partner.slug), 1),
                    _createElementVNode("td", _hoisted_4, [
                      (partner.enable_password)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                        : (_openBlock(), _createElementBlock("i", _hoisted_6))
                    ]),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(partner.enable_password ? partner.password : '-'), 1),
                    (partner.enable_password)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                          (partner.rotate_password)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                            : (_openBlock(), _createElementBlock("i", _hoisted_10))
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_11, "-")),
                    (partner.enable_password)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                          (partner.rotation_end_date)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.moment(partner.rotation_end_date).format("MM/DD/YYYY")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, "-"))
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_15, "-")),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(partner.enable_password && partner.rotate_password ? partner.rotation_frequency + ' days' : '-'), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-xs btn-primary",
                        onClick: ($event: any) => (_ctx.showEditModal(partner))
                      }, _cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
                      ]), 8, _hoisted_17)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : (!_ctx.loading && !_ctx.partners)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[12] || (_cache[12] = [
            _createElementVNode("p", null, "No partners in system", -1)
          ])))
        : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      modelValue: _ctx.show_edit_modal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.show_edit_modal) = $event))
    }, {
      header: _withCtx(() => _cache[13] || (_cache[13] = [
        _createTextVNode("Edit Partner Password Settings")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn btn-md btn-secondary",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeEditModal && _ctx.closeEditModal(...args)))
        }, "Cancel"),
        _createElementVNode("button", {
          class: "btn btn-md btn-primary",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.savePartner && _ctx.savePartner(...args)))
        }, "Save")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.edit_partner?.short_name), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", null, [
            _cache[14] || (_cache[14] = _createTextVNode("Enable Password ")),
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enable_password) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.enable_password]
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.enable_password ? 'form-group' : 'text-muted form-group')
        }, [
          _cache[15] || (_cache[15] = _createElementVNode("label", null, "Password ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            maxlength: "25",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            disabled: !_ctx.enable_password
          }, null, 8, _hoisted_20), [
            [_vModelText, _ctx.password]
          ]),
          _createElementVNode("button", {
            class: "btn btn-sm btn-primary ms-2",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.generatePassword && _ctx.generatePassword(...args))),
            disabled: !_ctx.enable_password
          }, "Generate", 8, _hoisted_21),
          (_ctx.password_error.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.password_error), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.enable_password ? 'form-group' : 'text-muted form-group')
        }, [
          _createElementVNode("label", null, [
            _cache[16] || (_cache[16] = _createTextVNode("Rotate Password ")),
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rotate_password) = $event)),
              disabled: !_ctx.enable_password
            }, null, 8, _hoisted_23), [
              [_vModelCheckbox, _ctx.rotate_password]
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.enable_password && _ctx.rotate_password ? 'form-group' : 'text-muted form-group')
        }, [
          _cache[17] || (_cache[17] = _createElementVNode("label", null, "Rotation Frequency", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rotation_frequency) = $event)),
            class: "ms-2",
            disabled: !_ctx.enable_password || !_ctx.rotate_password
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5,6,7], (day) => {
              return _createElementVNode("option", {
                key: day,
                value: day
              }, _toDisplayString(day) + " Days", 9, _hoisted_25)
            }), 64))
          ], 8, _hoisted_24), [
            [_vModelSelect, _ctx.rotation_frequency]
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.enable_password && _ctx.rotate_password ? 'form-group' : 'text-muted form-group')
        }, [
          _cache[18] || (_cache[18] = _createElementVNode("label", null, "Rotation end date ", -1)),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_datepicker, {
              placeholder: "Select Date...",
              modelValue: _ctx.rotation_end_date,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rotation_end_date) = $event)),
              "lower-limit": new Date(),
              disabled: !_ctx.enable_password || !_ctx.rotate_password
            }, null, 8, ["modelValue", "lower-limit", "disabled"])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "ms-2 btn btn-sm btn-primary",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearDate && _ctx.clearDate(...args)))
          }, "Clear")
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}